'use strict';

var common = require('../common');

var $body = $('body');
var $mainMenu = $('.main-menu');
var $modalBackground = $('.modal-background');

var detachMobileMenu = function () {
    $body.removeClass('sliding-modal-open');
    $modalBackground.hide();
    $mainMenu.removeClass('show-mobile-menu in').addClass('d-none').attr('aria-hidden', 'true');
};

module.exports = function () {
    $('.mb-close-menu-button').on('click', function (e) {
        e.preventDefault();
        detachMobileMenu();
        // to handle gold rates model
        $('.mb-metalrate-section').removeClass('active');
        $('.show-mobile-menu').removeClass('overflow-hidden');
        $('.mb-metalrate-section').find('.mb-metalrate-body').removeClass('show');
    });

    // hamburger toggler tab menu
    $('.navbar-toggler').click(function (e) {
        e.preventDefault();
        $('.sticky-nav.fixed-nav').removeClass('scroll-down d-none');
        $body.addClass('sliding-modal-open');
        $modalBackground.show();
        $mainMenu.addClass('show-mobile-menu').attr('aria-hidden', 'false');
    });

    var $parent = $('.mb-metalrate-section');
    var $goldRates = $parent.find('.mb-metalrate-body');
    $parent.on('click', function (e) {
        e.stopPropagation();
        $('.py-option-values').removeClass('show');
        $('.py-dropdown-icon').removeClass('rotate');
        $goldRates.toggleClass('show');
        $parent.toggleClass('active');
        $('.show-mobile-menu').toggleClass('overflow-hidden');
        if ($(window).width() <= 768) {
            if ($goldRates.hasClass('show')) {
                $goldRates.removeClass('dropdown-menu');
            }
        }
    });

    $(document).on('click', function (e) {
        if (
            !$parent.is(e.target) && $parent.has(e.target).length === 0 && !$goldRates.is(e.target) && $goldRates.has(e.target).length === 0
        ) {
            $goldRates.removeClass('show');
            $parent.removeClass('active');
            $('.show-mobile-menu').removeClass('overflow-hidden');
        }
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') {
            $goldRates.removeClass('show');
            $parent.removeClass('active');
            $('.show-mobile-menu').removeClass('overflow-hidden');
        }
    });
    $(window).on('resize', function () {
        if (window.innerWidth >= 1024 && $mainMenu.hasClass('in')) {
            $('.mb-close-menu-button').trigger('click');
        }
    });

    common.openLoginSignupModal('#signUpButtonMobile');

    $('.inr-tab').not('.sub-tabs').find('.nav-link').on('click', function () {
        $('.inr-tab').not('.sub-tabs').find('.nav-link')
            .removeClass('py-btn-primary')
            .addClass('py-btn-secondary');

        $(this).addClass('py-btn-primary').removeClass('py-btn-secondary');
    });

    $('.sub-tabs .nav-link').on('click', function () {
        $('.sub-tabs .nav-link')
            .removeClass('py-btn-primary')
            .addClass('py-btn-secondary');
        $(this).addClass('py-btn-primary').removeClass('py-btn-secondary');
    });
};
